var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0304 23 23 18.0215 23 11.9942C23 5.97852 18.0189 1 12 1C5.9696 1 1 5.97852 1 11.9942C1 18.0215 5.98113 23 12 23ZM12.1847 13.7038C12.6815 13.7038 12.9873 13.3981 12.9873 12.8503L13.1401 6.44268C13.1529 5.90764 12.7325 5.5 12.172 5.5C11.5987 5.5 11.2038 5.8949 11.2166 6.44268L11.3567 12.8503C11.3694 13.3981 11.6624 13.7038 12.1847 13.7038ZM12.1847 17.5C11.5478 17.5 11 16.9777 11 16.3535C11 15.7166 11.535 15.207 12.1847 15.207C12.8344 15.207 13.3694 15.7038 13.3694 16.3535C13.3694 16.9904 12.8217 17.5 12.1847 17.5Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircleFilled);
export default __webpack_public_path__ + "static/media/warning_circle_filled.8009c583f3b4258e8397ebb2506a5a7c.svg";
export { ForwardRef as ReactComponent };